/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentEditorQuestionCataloguesQuestionCreateResponse,
  ContentEditorQuestionCataloguesQuestionIndexResponse,
  ContentEditorQuestionCataloguesQuestionShowResponse,
  ContentEditorQuestionCataloguesQuestionUpdateResponse,
  ContentEditorTestDefinitionQuestionCreateResponse,
  ContentEditorTestDefinitionQuestionIndexResponse,
  ContentEditorTestDefinitionQuestionShowResponse,
  ContentEditorTestDefinitionQuestionUpdateResponse,
  QuestionCatalogueQuestionCreate,
  QuestionCatalogueQuestionUpdate,
  QuestionCreate,
  QuestionUpdate,
} from '../models';
import {
    ContentEditorQuestionCataloguesQuestionCreateResponseFromJSON,
    ContentEditorQuestionCataloguesQuestionCreateResponseToJSON,
    ContentEditorQuestionCataloguesQuestionIndexResponseFromJSON,
    ContentEditorQuestionCataloguesQuestionIndexResponseToJSON,
    ContentEditorQuestionCataloguesQuestionShowResponseFromJSON,
    ContentEditorQuestionCataloguesQuestionShowResponseToJSON,
    ContentEditorQuestionCataloguesQuestionUpdateResponseFromJSON,
    ContentEditorQuestionCataloguesQuestionUpdateResponseToJSON,
    ContentEditorTestDefinitionQuestionCreateResponseFromJSON,
    ContentEditorTestDefinitionQuestionCreateResponseToJSON,
    ContentEditorTestDefinitionQuestionIndexResponseFromJSON,
    ContentEditorTestDefinitionQuestionIndexResponseToJSON,
    ContentEditorTestDefinitionQuestionShowResponseFromJSON,
    ContentEditorTestDefinitionQuestionShowResponseToJSON,
    ContentEditorTestDefinitionQuestionUpdateResponseFromJSON,
    ContentEditorTestDefinitionQuestionUpdateResponseToJSON,
    QuestionCatalogueQuestionCreateFromJSON,
    QuestionCatalogueQuestionCreateToJSON,
    QuestionCatalogueQuestionUpdateFromJSON,
    QuestionCatalogueQuestionUpdateToJSON,
    QuestionCreateFromJSON,
    QuestionCreateToJSON,
    QuestionUpdateFromJSON,
    QuestionUpdateToJSON,
} from '../models';

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGetRequest {
    questionCatalogueId: number;
    term?: string;
    status?: string;
    categoryIds?: string;
    sort?: string;
    page?: number;
    perPage?: number;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDeleteRequest {
    questionCatalogueId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGetRequest {
    questionCatalogueId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPutRequest {
    questionCatalogueId: number;
    id: string;
    body?: QuestionCatalogueQuestionUpdate;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPostRequest {
    questionCatalogueId: number;
    body?: QuestionCatalogueQuestionCreate;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPostRequest {
    questionCatalogueId: number;
    questionId: number;
    body?: object;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPostRequest {
    questionCatalogueId: number;
    questionId: number;
    body?: object;
}

export interface ContentEditorTestsQuestionsGetRequest {
    testId: number;
}

export interface ContentEditorTestsQuestionsIdDeleteRequest {
    id: string;
}

export interface ContentEditorTestsQuestionsIdGetRequest {
    id: string;
}

export interface ContentEditorTestsQuestionsIdPutRequest {
    id: string;
    body?: QuestionUpdate;
}

export interface ContentEditorTestsQuestionsPostRequest {
    body?: QuestionCreate;
}

export interface ContentEditorTestsTestIdQuestionsGetRequest {
    testId: number;
    testId2: number;
}

export interface ContentEditorTestsTestIdQuestionsIdDeleteRequest {
    testId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsIdGetRequest {
    testId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsIdPutRequest {
    testId: number;
    id: string;
    body?: QuestionUpdate;
}

export interface ContentEditorTestsTestIdQuestionsPostRequest {
    testId: number;
    body?: QuestionCreate;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPostRequest {
    testId: number;
    questionId: number;
    body?: object;
}

/**
 * 
 */
export class QuestionApi extends runtime.BaseAPI {

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorQuestionCataloguesQuestionIndexResponse>>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.categoryIds !== undefined) {
            queryParameters['category_ids'] = requestParameters.categoryIds;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorQuestionCataloguesQuestionIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorQuestionCataloguesQuestionIndexResponse>> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDeleteRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDelete(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorQuestionCataloguesQuestionShowResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorQuestionCataloguesQuestionShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorQuestionCataloguesQuestionShowResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPutRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorQuestionCataloguesQuestionUpdateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionCatalogueQuestionUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorQuestionCataloguesQuestionUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPut(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorQuestionCataloguesQuestionUpdateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorQuestionCataloguesQuestionCreateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionCatalogueQuestionCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorQuestionCataloguesQuestionCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorQuestionCataloguesQuestionCreateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/publish`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPublishPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/purge_choices`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdPurgeChoicesPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsQuestionsGetRaw(requestParameters: ContentEditorTestsQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorTestDefinitionQuestionIndexResponse>>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsQuestionsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.testId !== undefined) {
            queryParameters['test_id'] = requestParameters.testId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/questions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorTestDefinitionQuestionIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorTestsQuestionsGet(requestParameters: ContentEditorTestsQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorTestDefinitionQuestionIndexResponse>> {
        const response = await this.contentEditorTestsQuestionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsQuestionsIdDeleteRaw(requestParameters: ContentEditorTestsQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsQuestionsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsQuestionsIdDelete(requestParameters: ContentEditorTestsQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsQuestionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsQuestionsIdGetRaw(requestParameters: ContentEditorTestsQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsQuestionsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsQuestionsIdGet(requestParameters: ContentEditorTestsQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionShowResponse> {
        const response = await this.contentEditorTestsQuestionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsQuestionsIdPutRaw(requestParameters: ContentEditorTestsQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsQuestionsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/questions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsQuestionsIdPut(requestParameters: ContentEditorTestsQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionUpdateResponse> {
        const response = await this.contentEditorTestsQuestionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsQuestionsPostRaw(requestParameters: ContentEditorTestsQuestionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/questions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsQuestionsPost(requestParameters: ContentEditorTestsQuestionsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionCreateResponse> {
        const response = await this.contentEditorTestsQuestionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorTestDefinitionQuestionIndexResponse>>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsGet.');
        }

        if (requestParameters.testId2 === null || requestParameters.testId2 === undefined) {
            throw new runtime.RequiredError('testId2','Required parameter requestParameters.testId2 was null or undefined when calling contentEditorTestsTestIdQuestionsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.testId2 !== undefined) {
            queryParameters['test_id'] = requestParameters.testId2;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorTestDefinitionQuestionIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsGet(requestParameters: ContentEditorTestsTestIdQuestionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorTestDefinitionQuestionIndexResponse>> {
        const response = await this.contentEditorTestsTestIdQuestionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdDeleteRaw(requestParameters: ContentEditorTestsTestIdQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdDelete(requestParameters: ContentEditorTestsTestIdQuestionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsTestIdQuestionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionShowResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdGet(requestParameters: ContentEditorTestsTestIdQuestionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionShowResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdPutRaw(requestParameters: ContentEditorTestsTestIdQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionUpdateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsIdPut(requestParameters: ContentEditorTestsTestIdQuestionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionUpdateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsPostRaw(requestParameters: ContentEditorTestsTestIdQuestionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionQuestionCreateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionQuestionCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsPost(requestParameters: ContentEditorTestsTestIdQuestionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionQuestionCreateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPostRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/purge_choices`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPost(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsTestIdQuestionsQuestionIdPurgeChoicesPostRaw(requestParameters, initOverrides);
    }

}
